import React from "react";
import QRCode from "react-qr-code";

export default function CreateQR({ size, value }) {
  return <QRCode size={size} value={value} viewBox={`0 0 256 256`} />;
}
